import React, { Component } from 'react';
import './Component.css';
import OriginArea from './OriginArea/OriginArea.jsx';
import './Intro.css';
import * as d3 from 'd3';
import ReadMore from './ReadMore/ReadMore.jsx';

const continents = ["Oceania", "Europe", "Asia", "Americas", "Africa"];

class Legend extends Component {
	render() {
		let rendered = continents.map((continent,i) =>
			<div class="item">
				<div
					class="square"
					style={{backgroundColor: d3.interpolateViridis(i/6)}}
				></div>
				<div class="label">
					{continent}
				</div>
			</div>
		);

		return <div class="legend"><div class="item">Permanent immigrant arrivals from:</div>{rendered}</div>
	}
}

class Intro extends Component {
	render() {
		let margin = 20;
		if (this.props.width < 1000) {
			margin = 10;
		}

		if (this.props.width < 800) {
			margin = 0;
		}
		return (
		<div className="Component" id="intro">
			<div className="text">
				<p>Diversification is one of the key social processes that defines our times. Over the past few decades, multiple causes and categories of migration – combined with migrants’ new and varying origins – have been transforming urban populations in complex ways, worldwide. The following graphics show us how.</p>
			</div>
			<ReadMore
				content={["Across the globe, most international migrants end up in cities. Urban populations today show fluctuating combinations of nationality, ethnicity, language, religion, age, gender, legal status, class and human capital. Such changing combinations of traits lead to conditions of ‘super-diversity’ – a concept highlighting the fact that current diversity patterns significantly supersede earlier ones.",
				"An important feature of contemporary super-diversification is that new migrants tend to inhabit places where migrants from previous waves and generations still live. The characteristics of new migrants, therefore, are ‘layered’ on top of earlier kinds of diversity. Further, super-diversification also entails growing differences among people within ethnic, religious and national categories: although they share the same ethnic or religious label, their socio-economic and other characteristics are very different. In all these ways, urban populations are becoming ever more complex.",
				"Super-diversification does not inherently present a threat to social cohesion. A range of research shows that people are creating and practicing new, crosscutting contacts and relationships in diversifying cities every day. However, super-diversification does present analysts, policymakers and the public with challenges to understand the complex ways that urban societies are changing. New methods for correlating complex data are needed, just as – if not more significantly – new ways of seeing emergent patterns in complex data. For these reasons and purposes, we have created an array of new, interactive data visualization tools for readily observing patterns of urban super-diversification."]
			} />

			<div className="metropolis-video">
				<iframe src="https://player.vimeo.com/video/311667162?title=0&byline=0&portrait=0" width="640" height="360" frameBorder="0" allowFullScreen></iframe>
				<p>Keynote Lecture, 2018 International Metropolis Conference, Sydney</p>
			</div>

			<div className="graphic">
				<div className="area-title" style={{marginBottom: "0px"}}>
                    {"Changing sources of permanent migration"}
                </div>
				<div className="Intro-canada">
					<p className="Intro-chart-title">Canada</p>
					<div className="Intro-chart">
						<OriginArea
							city="vancouver"
							width={this.props.width/3 - margin}
							height={250} />
					 </div>
				</div>
				<div className="Intro-australia">
					<p className="Intro-chart-title">Australia</p>
					<div className="Intro-chart">
						<OriginArea
							city="sydney"
							width={this.props.width/3 - margin}
							height={250} />
					</div>
				</div>
				<div className="Intro-newzealand">
					<p className="Intro-chart-title">New Zealand</p>
					<div className="Intro-chart">
						<OriginArea
							city="auckland"
							width={this.props.width/3 - margin}
							height={250} />
					</div>
				</div>
			</div>

			<div className="graphic">
				<Legend />
			</div>

			<div className="text">
				<p>The cities of Vancouver, Sydney and Auckland—based in three major countries of current global migration—powerfully represent and demonstrate processes of urban super-diversification. The nature of these cities has been fundamentally shaped by immigration. Nearly 40 percent of metropolitan Auckland’s residents, as recorded in the 2013 census, were born outside New Zealand, and the corresponding figures for Sydney and Vancouver in 2016 were, respectively, 43 and 41 percent. All three are on a path to become ‘majority-minority cities’, with populations that trace their ancestry to Asia, Latin America, and Africa projected to exceed those who identify as European in origin.</p>
				<p>You can explore this national-scale information further below. Next, a metropolitan scale visualization examines the connections between different types of diversity, and a second explores the relationship between diversity and socio-economic outcomes. Third, we investigate the neighbourhood scale of these conurbations through mapping social geography and diversity ‘hot spots.’ Finally, a dashboard tool interrogates how the demographic characteristics intersect in diverse ways with socio-economic status.</p>
			</div>
		</div>
		);
	}
}

export default Intro;



// WEBPACK FOOTER //
// ./src/Intro.js